import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import { useManageDiscountCategory } from './hooks/useManageDiscountCategory';

const manageDiscountFormSchema = z.object({
  category: z.string().trim().min(1, { message: 'common.form.validation.required' }),
  description: z.string().trim().min(1, { message: 'common.form.validation.required' }),
});

export const ManageDiscountForm = ({
  defaultValues,
  categoryId,
}: {
  defaultValues?: { category: string; description: string };
  categoryId?: string;
}) => {
  const formDefaultValues = defaultValues ?? { category: '', description: '' };
  const form = useForm({ schema: manageDiscountFormSchema, mode: 'onBlur', defaultValues: formDefaultValues });
  const { t } = useDynamicLocale();
  const { mutateAsync } = useManageDiscountCategory();

  return (
    <Form
      form={form}
      onSubmit={async (values) => {
        await mutateAsync({
          categoryId: categoryId ?? '',
          categoryName: values.category,
          categoryDescription: values.description,
        });
      }}
    >
      <div className="flex flex-col gap-4.5">
        <Input
          label="configurationManagement.discountManagement.manageDiscount.category"
          {...form.register('category')}
          placeholder={t('configurationManagement.discountManagement.manageDiscount.categoryPlaceholder')}
        />
        <Input
          label="configurationManagement.discountManagement.manageDiscount.categoryDescription"
          {...form.register('description')}
          placeholder={t('configurationManagement.discountManagement.manageDiscount.categoryDescriptionPlaceholder')}
        />
      </div>
    </Form>
  );
};
